import { useState } from "react";
import { Modal } from "@mui/material"
import { useDispatch, useSelector } from "react-redux";

import { openCheckout } from "../../../actions/payments";

import * as paymentsService from "../../../services/payments";

import Button from "../../Button"
import InputText from "../../Inputs/Text";

import './styles.css'
import { useNavigate } from "react-router-dom";

const AddCreditModal = ({
    open,
    onClose
}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    
    const account = useSelector((state) => state.accounts.data);

    const [amount, setAmount] = useState(0);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        setLoading(true);
        const response = await paymentsService.createPayment({
            amount: parseFloat(amount) * 100,
            uuidAccount: account.uuid,
        })

        if (response) {
            setAmount(0);
            onClose();
            dispatch(openCheckout(response))
            navigate('/checkout');
        }

        setLoading(false);
    }

    return (
        <Modal 
            open={open} 
            onClose={onClose}
        >
            <div className="add-credit-modal">
                {/* Header */}
                <div className="add-credit-header">
                    <div className="add-credit-header-title">
                        <h2>Add Credit</h2> 
                        <Button 
                            kind="link" 
                            label="Models & Pricing" 
                            onClick={() => navigate('/models')}
                            style={{flex: 1, display: 'flex', justifyContent: "end"}}
                        />
                    </div>
                    <p>
                        Add credit to your account to ensure you have sufficient balance for transactions. 
                        You can add any amount, and it will be reflected in your account balance immediately.
                    </p>
                </div>
                {/* Body */}
                <div className="add-credit-body">
                    <InputText
                        type="number"
                        prefix="$"
                        label="Amount to add"
                        helperText="Enter the amount you want to add to your account balance."
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                        error={amount <= 0}
                    />
                </div>
                {/* Footer */}
                <div className="add-credit-footer">
                    <Button 
                        kind="link" 
                        label="Cancel" 
                        onClick={onClose} 
                        style={{display: 'flex', justifyContent: "start"}}
                    />
                    <Button 
                        kind="primary" 
                        label="Add Credit"
                        disabled={amount <= 0}
                        loading={loading}
                        onClick={handleSubmit} 
                    />
                </div>
            </div>
        </Modal>
    )
}

export default AddCreditModal